import {ReactNode, useMemo, useState} from "react";

import {FlagGbIcon, FlagPlIcon, FlagRuIcon, FlagUaIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";

import {useWeglotContext} from "../hooks/use_weglot_context";
import {LangSelect} from "./LangSelect";

import * as styles from "./WeglotLangSwitcher.module.css";

interface IProps {
    isMobile: boolean;
    onLangChange?: (langCode: string) => void;
}

const LANG_OPTIONS = [
    {value: "pl", flag: FlagPlIcon, text: "Polski"},
    {value: "en", flag: FlagGbIcon, text: "English"},
    {value: "uk", flag: FlagUaIcon, text: "Yкраїнська"},
    {value: "ru", flag: FlagRuIcon, text: "Русский"}
] as const;

const MODAL_LABELS: Record<string, string> = {
    pl: "Wybierz język",
    en: "Select language",
    uk: "Виберіть мову",
    ru: "Выберите язык"
};

const buildLangOptions = (): {value: string; label: ReactNode}[] =>
    LANG_OPTIONS.map((langOption) => {
        const FlagIcon = langOption.flag;

        return {
            value: langOption.value,
            label: (
                <div className={styles.langRow}>
                    <FlagIcon size="2.8" wrapperSize="2.8" wrapperColor="transparent" />
                    <Text variant="body_copy_1">{langOption.text}</Text>
                </div>
            )
        };
    });

export function WeglotLangSwitcher({isMobile, onLangChange}: IProps) {
    const {weglot} = useWeglotContext();
    const langOptions = useMemo(buildLangOptions, []);
    const [activeLang, setActiveLang] = useState<string>();

    if (!weglot) return null;

    const modalLabel = MODAL_LABELS[activeLang ?? weglot.getCurrentLang()] ?? MODAL_LABELS.pl;

    const handleLangChange = (newValue: {value: string}) => {
        setActiveLang(newValue.value);
        weglot.switchTo(newValue.value);
        onLangChange?.(newValue.value);
    };

    return (
        <div className={`lang-switcher-wrap ${styles.langSwitcher} ${isMobile ? ` ${styles.langSwitcherFullWidth}` : ""}`}>
            <LangSelect
                isMobile={isMobile}
                initialValue={weglot.getCurrentLang()}
                instanceId="weglot-lang-switcher"
                menuPlacement="auto"
                menuPosition="fixed"
                radioName="lang"
                options={langOptions}
                onChange={handleLangChange}
                modalLabel={modalLabel}
                styles={{
                    container: (baseStyles) => ({
                        ...baseStyles,
                        width: isMobile ? "100%" : baseStyles.width,
                        minWidth: isMobile ? "100% !important" : "auto !important"
                    }),
                    menu: (baseStyles) => ({
                        ...baseStyles,
                        width: "max-content",
                        minWidth: "100%"
                    })
                }}
                className={isMobile ? styles.langSelectFullWidth : styles.langSelect}
            />
        </div>
    );
}
import {ReactNode, useMemo, useState} from "react";

import {FlagGbIcon, FlagPlIcon, FlagRuIcon, FlagUaIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";

import {useWeglotContext} from "../hooks/use_weglot_context";
import {LangSelect} from "./LangSelect";

import * as styles from "./WeglotLangSwitcher.module.css";

interface IProps {
    isMobile: boolean;
    onLangChange?: (langCode: string) => void;
}

const LANG_OPTIONS = [
    {value: "pl", flag: FlagPlIcon, text: "Polski"},
    {value: "en", flag: FlagGbIcon, text: "English"},
    {value: "uk", flag: FlagUaIcon, text: "Yкраїнська"},
    {value: "ru", flag: FlagRuIcon, text: "Русский"}
] as const;

const MODAL_LABELS: Record<string, string> = {
    pl: "Wybierz język",
    en: "Select language",
    uk: "Виберіть мову",
    ru: "Выберите язык"
};

const buildLangOptions = (): {value: string; label: ReactNode}[] =>
    LANG_OPTIONS.map((langOption) => {
        const FlagIcon = langOption.flag;

        return {
            value: langOption.value,
            label: (
                <div className={styles.langRow}>
                    <FlagIcon size="2.8" wrapperSize="2.8" wrapperColor="transparent" />
                    <Text variant="body_copy_1">{langOption.text}</Text>
                </div>
            )
        };
    });

export function WeglotLangSwitcher({isMobile, onLangChange}: IProps) {
    const {weglot} = useWeglotContext();
    const langOptions = useMemo(buildLangOptions, []);
    const [activeLang, setActiveLang] = useState<string>();

    if (!weglot) return null;

    const modalLabel = MODAL_LABELS[activeLang ?? weglot.getCurrentLang()] ?? MODAL_LABELS.pl;

    const handleLangChange = (newValue: {value: string}) => {
        setActiveLang(newValue.value);
        weglot.switchTo(newValue.value);
        onLangChange?.(newValue.value);
    };

    return (
        <div className={`lang-switcher-wrap ${styles.langSwitcher} ${isMobile ? ` ${styles.langSwitcherFullWidth}` : ""}`}>
            <LangSelect
                isMobile={isMobile}
                initialValue={weglot.getCurrentLang()}
                instanceId="weglot-lang-switcher"
                menuPlacement="auto"
                menuPosition="fixed"
                radioName="lang"
                options={langOptions}
                onChange={handleLangChange}
                modalLabel={modalLabel}
                styles={{
                    container: (baseStyles) => ({
                        ...baseStyles,
                        width: isMobile ? "100%" : baseStyles.width,
                        minWidth: isMobile ? "100% !important" : "auto !important"
                    }),
                    menu: (baseStyles) => ({
                        ...baseStyles,
                        width: "max-content",
                        minWidth: "100%"
                    })
                }}
                className={isMobile ? styles.langSelectFullWidth : styles.langSelect}
            />
        </div>
    );
}
